export const VALIDITY = Object.freeze({
    invalid: 'invalid',
    valid: 'valid',
    untouched: 'untouched',
});
